import React from 'react';
import { format } from 'date-fns';

const TYPE_COLORS = {
  'Work Achievement':     'bg-gray-100 text-gray-600',
  'Personal Achievement': 'bg-gray-100 text-gray-600',
  'Learning Achievement': 'bg-gray-100 text-gray-600',
};

const CompactAchievementItem = ({ achievement, isSelected = false, onClick }) => {
  const formatDate = (dateString) => {
    try {
      const [year, month, day] = dateString.split('T')[0].split('-').map(Number);
      return format(new Date(year, month - 1, day), 'MMM d, yyyy');
    } catch {
      return dateString;
    }
  };

  const typeColor = TYPE_COLORS[achievement.status] || 'bg-gray-100 text-gray-600';

  return (
    <div
      onClick={() => onClick(achievement)}
      className={`px-4 py-3.5 border-b border-gray-200 cursor-pointer transition-colors border-l-4 ${
        isSelected
          ? 'bg-white border-l-indigo-500'
          : 'border-l-transparent hover:bg-white'
      }`}
    >
      {/* Title + badges */}
      <div className="flex items-start justify-between gap-2 mb-1.5">
        <p className={`text-sm leading-snug flex-1 ${isSelected ? 'font-semibold text-gray-900' : 'font-medium text-gray-700'}`}>
          {achievement.title}
        </p>
        <div className="flex items-center gap-1 shrink-0">
          {!!achievement.endorsed && (
            <span className="inline-flex items-center gap-0.5 px-1.5 py-0.5 text-xs font-semibold rounded-full bg-green-100 text-green-700 border border-green-200">
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
              </svg>
              Verified
            </span>
          )}
          {!!achievement.is_highlight && !achievement.endorsed && (
            <svg className="w-3.5 h-3.5 text-amber-600 shrink-0" fill="currentColor" viewBox="0 0 24 24" title="Highlight">
              <path d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"/>
            </svg>
          )}
        </div>
      </div>

      {/* Type + date */}
      <div className="flex items-center justify-between">
        <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${typeColor}`}>
          {achievement.status?.replace(' Achievement', '') || 'Work'}
        </span>
        <span className="text-xs text-gray-400">{formatDate(achievement.date)}</span>
      </div>
    </div>
  );
};

export default CompactAchievementItem;
